<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	// Services and configs
	import { devices_config } from 'src/configs/devices';
	// Helpers
	import { get_mode, real_id, lightDevicesWithoutModeSwitch } from 'src/helpers/interface_helpers';
	// Design System Components
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	// Components
	import ControlMode from 'src/components/Controls/Single/ControlMode.svelte';
	import ControlTemp from 'src/components/Controls/Single/ControlTemp.svelte';
	// Types
	import type { Device } from 'src/types/Device.ts';

	/**
	 * Secondary controls tab for the S3BL-D010009AEU (Gen3 CCT Bulb) sidepanel drawer.
	 *
	 * Responsibilities:
	 * - provides temperature control for CCT mode
	 *
	 * @prop device Active device selected in the sidepanel drawer. Expected to be a Gen3 CCT bulb.
	 */
	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: mode = get_mode(device, status, settings);
	$: deviceConfig = devices_config?.[device?.type];

	// Check if device has color temp control
	$: hasColorTempControl = deviceConfig?.modes?.[mode]?.color_temp;
</script>

<SidepanelContent>
	{#if device && typeof status !== 'undefined' && typeof settings !== 'undefined' && deviceConfig !== undefined}
		{#if hasColorTempControl && !lightDevicesWithoutModeSwitch(device.type)}
			<ControlMode {device} {settings} {mode} />
		{/if}
		{#if mode === 'white' || mode === 'cct' || device.mode === 'cct'}
			<ControlTemp {device} {status} />
		{:else if mode === 'rgbcct' && settings?.[`${mode}:0`]?.mode !== 'cct'}
			<ControlTemp {device} {status} />
		{/if}
	{:else}
		<div class="loading-state">
			<div class="flex-full-height"></div>
		</div>
	{/if}
</SidepanelContent>
